import { render, staticRenderFns } from "./InstallScriptDisplay.vue?vue&type=template&id=c886919c&scoped=true&"
import script from "./InstallScriptDisplay.vue?vue&type=script&lang=js&"
export * from "./InstallScriptDisplay.vue?vue&type=script&lang=js&"
import style0 from "./InstallScriptDisplay.vue?vue&type=style&index=0&id=c886919c&scoped=true&lang=scss&"
import style1 from "./InstallScriptDisplay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c886919c",
  null
  
)

export default component.exports